import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from './services/config.service';
import { Validators } from '@angular/forms';
declare var $: any;
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'build-form',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'Add/Edit a Form';
    incrementer = 0;

    config: any[] = [];
    previewConfig: any[] = [];
    formFieldsToAdd = [];

    defaultFormField = 'text';

    newFormFields = { name: 'MyNewForm', fields: [] };
    formName: string = '';
    formDescription: string = '';

    @Output()
    save: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    formSubmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(private configService: ConfigService, private http: HttpClient) {
        this.formFieldsToAdd = this.configService.formFieldsToAdd;

        this.configService
            .getEditFormFields()
            .subscribe(
            form => {
                const my_current_form = JSON.parse(form.toString());

                    if (my_current_form.formJson != null) {
                        //my_current_form.formJsonString = my_current_form.formJsonString.replace(/&quot;/g, '"');
                        my_current_form.formJson = JSON.parse(my_current_form.formJsonString);
                        this.configService.editConfig([...my_current_form.formJson]);
                        this.formName = my_current_form.name || '';
                        this.formDescription = my_current_form.description || '';
                        this.incrementer = my_current_form.incrementer || (my_current_form.fields ? my_current_form.fields.length : 1);
                    }
                },
                error => {
                    console.error(error);
                    this.configService.editConfig([]);
                }
            );
    }

    ngOnInit() {
        this.configService.cast.subscribe(config => {
            this.config = [...config]
            this.previewConfig = [...config]
            this.previewConfig = this.previewConfig.map(conf => {
                let previewConf = { ...conf }
                if (conf.name.indexOf('-preview') == -1) previewConf.name = previewConf.name + '-preview';
                previewConf["controlType"] = "preview";
                return previewConf;
            })
        });
    }

    formSubmitted(formFieldValues) {
        const submittedValues = { ...formFieldValues };

        // Replace truthy checkbox values with corresponding text value
        const checkboxValues = this.configService.allCheckboxValues;
        Object.keys(checkboxValues).map(key => {
            submittedValues[key] = checkboxValues[key];
        });

        // Replace file name with actual File content for all file upload fields
        const fileUploads = this.configService.allUploadedFiles;
        Object.keys(fileUploads).map(key => {
            submittedValues[key] = fileUploads[key];
        });

        const userForm = {
            'name': this.formName,
            'description': this.formDescription,
            'values': submittedValues
        };
        this.formSubmit.emit(userForm);
    }

    saveForm(myFormName) {
        let newFormFields = this.config;
        //05/08/2021 when we save the form from the designer view, we are removing the control type
        //There are two controlTypes (design, preview). This is used for not showing the label for infoMessage and Terms checkboxes
        //we do not need to store the controlType and also this makes it backwards compatible
        newFormFields = newFormFields.map(this.removeValidator).map(this.removeControlType);

        const myForm = {
            'name': myFormName,
            'description': '',
            'incrementer': this.incrementer,
            'formType': 1,
            "formId": $("#hdnFormId").val(),
            'formJson': JSON.stringify(newFormFields)
        };

        this.http.post($("#hdnSaveUrl").val(), myForm).subscribe(resp => {
            window.location.href = $("#hdnFormListUrl").val();
        });
    }

    removeValidator(fieldConfig) {
        delete fieldConfig.validators;
        return fieldConfig;
    }

    removeControlType(fieldConfig) {
        delete fieldConfig.controlType;
        return fieldConfig;
    }

    // function to handle addition of a new form field on clicking the button
    // based on the field required.
    addField(inputType: string) {
        this.incrementer = this.incrementer + 1;
        const configField = { ...this.configService.newConfigFields[inputType] };
        configField['name'] = configField['name'] + this.incrementer;
        configField['position'] = this.config.length + 1;
        this.configService.editConfig([...this.config, configField]);
    }

    // handles removing all fields by sending in an empty array as new fields
    removeAllFields() {
        this.configService.editConfig([]);
    }
}
